<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      providerState: null
    };
  },
  created() {
    this.getProvider()
      .then(res => {
        this.getStates();
      });
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      countryList: 'countryList'
    }),
    providerCountry() {
      return this.countryList.find(country => country.id == this.provider.country_id);
    },
    providerAddress() {
      let street = this.provider.street ? this.provider.street.replace(/ ,/g, ',') : '';
      let city = this.provider.city ? `${this.provider.city}, ` : '';
      let state = this.providerState ? `${this.providerState.code} ` : '';
      let zip = this.provider.zip_code || '';
      let country = this.providerCountry ? this.providerCountry.name : '';
      let phone = this.provider.phone || ''

      return {
        line_1: street,
        line_2: `${city}${state}${zip}`,
        line_3: country
      };
    },
    providerName() {
      return this.provider.name || '';
    },
    providerPhone() {
      return this.provider.phone || '';
    }
  },
  methods: {
    ...mapActions({
      getProvider: 'getProvider',
      getStateList: 'getStateList'
    }),
    getStates() {
      if (this.countryList.length && this.provider.country_id)
        this.getStateList(this.provider.country_id)
          .then(res => {
            if (this.providerCountry && this.providerCountry.states)
              this.providerState = this.providerCountry.states.find(state => state.id == this.provider.state_id);
          });
    },
  },
  watch: {
    countryList() {
      this.getStates();
    },
    provider() {
      this.getStates();
    }
  },
}
</script>